import { BusinessType } from '@/@types/generated/models/BusinessType'
import { register } from './enum'

const BusinessTypeLabels: Record<BusinessType, string> = {
  [BusinessType.CORPORATION]: 'Corporation',
  [BusinessType.LIMITED_LIABILITY_COMPANY]: 'Limited Liability Company (LLC)',
  [BusinessType.LIMITED_LIABILITY_PARTNERSHIP]:
    'Limited Liability Partnership (LLP)',
  [BusinessType.LIMITED_PARTNERSHIP]: 'Limited Partnership (LP)',
  [BusinessType.GENERAL_PARTNERSHIP]: 'General Partnership',
  [BusinessType.SOLE_PROPRIETOR]: 'Sole Proprietorship',
  [BusinessType.OTHER]: 'Other',
}

register<BusinessType>(BusinessType, (v) => {
  if (!v) return '\u2014'
  return BusinessTypeLabels[v]
})
